<div *ngIf="isMobile && hamburgerClicked" class="overlay"></div>
<div *ngIf="showBanner" class="banner">
    <h1>Viewing as {{userData.FirstName}} {{userData.LastName}} - {{userRights}}, {{selectedClientName}}</h1>
</div>
<app-embed-header></app-embed-header>
<div *ngIf="isMobile && hamburgerClicked" #mobileSidenav id="mobileSidenav" [@slideInOut] class="mobile-sidenav">
    <mat-nav-list>
        <button class="close" mat-button (click)="closeSideNavMenu()">X</button>
        <div class="icon-container" [ngClass]="{'selected': selectedPage == 'pinsheet'}">
            <a [routerLink]="['/embed/pinsheet']" (click)="closeSideNavMenu();setSelectedPage('pinsheet')" routerLinkActive="active">
                <img class="icon" src="../../../../assets/images/Sidenav/pinsheet.svg" alt="pinsheet"/>
                <span class="icon-name">Pinsheet</span>
            </a>
        </div>
        <div [hidden]="user" class="icon-container" [ngClass]="{'selected': selectedPage == 'manage'}"
            [ngClass]="{'disabled': isClubCarRelated && isLayoutEditable}">
            <a [routerLink]="['/embed/manage']" (click)="closeSideNavMenu();setSelectedPage('manage')" routerLinkActive="active">
                <img class="icon" src="../../../../assets/images/Sidenav/manageGreen.svg" alt="manage"/>
                <span class="icon-name">Manage Greens</span>
            </a>
        </div>
        <div class="icon-container" [ngClass]="{'selected': selectedPage == 'events'}"
            [hidden]="isClubCarRelated">
            <a [routerLink]="['/embed/events']" (click)="closeSideNavMenu();setSelectedPage('events')" routerLinkActive="active">
                <img class="icon" src="../../../../assets/images/Sidenav/event.svg" alt="events"/>
                <span class="icon-name">Events</span>
            </a>
        </div>
        <div class="icon-container">
            <div class="hs-cta-embed hs-cta-simple-placeholder hs-cta-embed-216905172848"
                style="max-width:100%" data-hubspot-wrapper-cta-id="216905172848">
                <a href="https://cta-service-cms2.hubspot.com/web-interactives/public/v1/track/redirect?encryptedPayload=AVxigLJnWsjdw47SuiRqu1%2BBAyu6t7K3r5bnsnrGQUltXti8x3qTreiHFc4lzKvNG4jNzTdSEGaqe2VfXrH5Sv9GlrlXYyZDYFqzxu6KikzICJHJgrbyd6IzZIbP8R2HwyGtvoWffb1Kn9uY%2BDfR9R98nqSFBNT5Yy3LJZOFy9%2B6LrNgXnMYU6pUNhXlNp31rnomUpMqq4eEv3siv8rU%2Bh4MI%2BR2maaK8%2FpCYxGvchvWPr0YvCV8%2F50%2FyQAjPHYlSO%2B7&amp;webInteractiveContentId=216905172848&amp;portalId=4652692" target="_blank" rel="noopener" crossorigin="anonymous" (click)="closeSideNavMenu()">
                    <img class="icon geoez" alt="GEOEZ circle transparent V2" loading="lazy" src="https://no-cache.hubspot.com/cta/default/4652692/interactive-216905172848.png" onerror="this.style.display='none'" />
                    <span class="icon-name">GEOEZ</span>
                </a>
            </div>
        </div>
    </mat-nav-list>
</div>
<mat-sidenav-container class="side-navigations" [ngClass]="{'imp-side-navigations': showBanner}">
    <mat-sidenav *ngIf="!isMobile" opened class="sidenav-list-container" mode="side">
        <mat-nav-list>
            <div matTooltip="Pinsheet">
                <a [routerLink]="['/embed/pinsheet']" routerLinkActive="active"><img class="pinsheet"
                        src="../../../../assets/images/Sidenav/pinsheet.svg" alt="pinsheet " /></a>
            </div>
            <div [hidden]="user || member" matTooltip="Manage Greens" matTooltipClass="side-menu" [ngClass]="{'disabled': isClubCarRelated && isLayoutEditable}">
                <a [routerLink]="['/embed/manage']" routerLinkActive="active"><img class="manage"
                        src="../../../../assets/images/Sidenav/manageGreen.svg" alt="manage " /></a>
            </div>
            <div matTooltip="Events" matTooltipClass="side-menu" [hidden]="isClubCarRelated">
                <a [routerLink]="['/embed/events']" routerLinkActive="active"><img class="events"
                        src="../../../../assets/images/Sidenav/event.svg" alt="events " /></a>
            </div>
            <div matTooltip="GEOEZ" matTooltipClass="side-menu">
                <div class="hs-cta-embed hs-cta-simple-placeholder hs-cta-embed-216905172848"
                    style="max-width:100%; display:flex; justify-content:center" data-hubspot-wrapper-cta-id="216905172848">
                    <a href="https://cta-service-cms2.hubspot.com/web-interactives/public/v1/track/redirect?encryptedPayload=AVxigLJnWsjdw47SuiRqu1%2BBAyu6t7K3r5bnsnrGQUltXti8x3qTreiHFc4lzKvNG4jNzTdSEGaqe2VfXrH5Sv9GlrlXYyZDYFqzxu6KikzICJHJgrbyd6IzZIbP8R2HwyGtvoWffb1Kn9uY%2BDfR9R98nqSFBNT5Yy3LJZOFy9%2B6LrNgXnMYU6pUNhXlNp31rnomUpMqq4eEv3siv8rU%2Bh4MI%2BR2maaK8%2FpCYxGvchvWPr0YvCV8%2F50%2FyQAjPHYlSO%2B7&amp;webInteractiveContentId=216905172848&amp;portalId=4652692" target="_blank" rel="noopener" crossorigin="anonymous">
                        <img class="geoez-menu-logo" alt="GEOEZ circle transparent V2" loading="lazy" src="https://no-cache.hubspot.com/cta/default/4652692/interactive-216905172848.png" onerror="this.style.display='none'" />
                    </a>
                </div>
            </div>
        </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content id="main-content">
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>